import { Checkbox } from "@material-ui/core";
import React, { useEffect } from "react";

import { UserLevel } from "../../../enums/userLevel";
import { useAuth } from "../../../features/auth/context";
import { FormField } from "../../shared/formField";

interface Props {
    value: boolean;
    onChange: (value: boolean) => void;
    userLevel: UserLevel | null;
    disabled?: boolean;
}
export function IsInactiveEmployeeFormField({
    value,
    onChange,
    userLevel,
    disabled = false,
}: Props) {
    const { isGlobalAdmin, isSiteAdmin } = useAuth();

    const deactivationDisabled = !(isGlobalAdmin || isSiteAdmin);

    useEffect(() => {
        if (userLevel !== UserLevel.SiteEmployee) {
            onChange(false);
        }
    }, [userLevel, onChange]);

    if (userLevel !== UserLevel.SiteEmployee) {
        return null;
    }

    return (
        <FormField
            label="Deactivated"
            disabledReason={deactivationDisabled ? "Insufficient permissions to modify" : undefined}
        >
            <Checkbox
                checked={value}
                color="primary"
                size="medium"
                onChange={(event) => {
                    onChange(event.target.checked)
                }}
                disabled={disabled || deactivationDisabled}
            />
        </FormField>
    );
}
